import gql from 'graphql-tag';
import { GetAllLeasesQuery } from './index';

const CreateLeaseMutation = gql`
  mutation LeaseCreate($input: LeaseCreateInput!) {
    lease_create(input: $input) {
      id
    }
  }
`;

export const createLease = (client, operatorId, leaseName) => {
  const variables = {
    input: {
      operator_id: operatorId,
      name: leaseName,
    },
  };

  const options = {
    mutation: CreateLeaseMutation,
    variables,
    refetchQueries: [
      { query: GetAllLeasesQuery },
    ],
  };

  return client.mutate(options);
};
